// ./games/crash/state/phases/RevealPhase.ts
import type { StompMessage } from '@core/Web/types/StompMessage';
import type { StompPhaseUpdate } from '@core/Web/types/StompMessage';
import type { IPhase, PhaseContext } from './IPhase';

export class RevealPhase implements IPhase {
  private context: PhaseContext;
  private details: StompPhaseUpdate['p'];

  constructor(context: PhaseContext, details: StompPhaseUpdate['p']) {
    this.context = context;
    this.details = details;
  }

  onEnter(): void {
    console.log('[Phase] ==> Entering REVEAL phase.');

    const finalMultiplier = this.details.bust ?? 1.0;
    console.log(
      `[RevealPhase] Displaying final multiplier: ${finalMultiplier}x`
    );

    this.context.store.setState({
      phase: 'REVEAL',
      crashedAtX: finalMultiplier,
    });

    // Optional: Play reveal sound or trigger animation
    if (this.context.audio) {
      this.context.audio.play('reveal'); // or 'crash_reveal', etc.
    }
  }

  onExit(): void {
    console.log('[Phase] <== Exiting REVEAL phase.');
  }

  handleMessage(_message: StompMessage): void {
    // Can handle late ROUND_SUMMARY if needed
  }

  update(_deltaTime: number): void {
    // No updates needed
  }
}
